module.exports = __webpack_public_path__ + "src/img/beUse.594db02b.svg";